import * as React from 'react'
import { SAVED_VIEW_ICONS, type SavedViewIconKey } from './icons'
import * as s from './SavedViews.css'
import { useT } from '../../../../app/lib/i18n'

export interface IconPickerProps {
  value: string
  onChange: (key: SavedViewIconKey) => void
  color?: string
}

export function IconPicker({ value, onChange, color = '#6B7280' }: IconPickerProps) {
  const t = useT()
  return (
    <div className={s.iconGrid} role="listbox" aria-label={t('shared.savedView.icon')}>
      {SAVED_VIEW_ICONS.map(({ key, label, Icon }) => (
        <button
          key={key}
          type="button"
          className={s.iconCell}
          data-selected={value === key ? 'true' : undefined}
          title={label}
          aria-label={label}
          aria-selected={value === key}
          onClick={() => onChange(key)}
        >
          <Icon size={16} color={value === key ? color : undefined} />
        </button>
      ))}
    </div>
  )
}
